import * as React from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Markdown from './Modules/Components/Markdown';
import Typography from './Modules/Components/Typography';
import { AppNavBar } from './Modules/Views/AppNavBar';
import AppFooter from './Modules/Views/AppFooter';
import withRoot from './Modules/withRoot';

const Terms = () => {
	const [terms, setTerm] = React.useState('');
	React.useEffect(() => {
		import(`./Modules/Views/terms.md`)
			.then((res) => {
				fetch(res.default)
					.then((res) => res.text())
					.then((res) => setTerm(res))
					.catch((err) => console.log(err));
			})
			.catch((err) => console.log(err));
	});
	return (
		<React.Fragment>
			<AppNavBar />
			<Container>
				<Box sx={{ mt: 7, mb: 12 }}>
					<Typography
						variant="h3"
						gutterBottom
						marked="center"
						align="center"
					>
						Terms
					</Typography>
					<Markdown>{terms}</Markdown>
				</Box>
			</Container>
			<AppFooter />
		</React.Fragment>
	);
};

export default withRoot(Terms);
